/**
 * @ngdoc services
 * @memberof mercury.modules.cashup
 * @name CashupSets
 * @description Data access service for managing Cashups
 */
angular.module('mercury.modules.cashup')
.factory('CashupSets', ["$resource", "$http", "$q", "settings", function($resource, $http, $q, settings) {
  var CashupSet = $resource(settings.mercHost + '/cashup-sets/:id', {id: '@id'});
  var Tills = $resource(settings.mercHost + '/PosTills');

  /**
   * Get all CashupSets for a given period
   *
   * @memberof CashupSets
   * @param  {String} startTime start of period
   * @param  {String} endTime   end of period
   * @return {Object} promise
   */
  function get(startTime, endTime, companyId) {
    var deferred = $q.defer();
    var config = {
      params: {start: startTime, end: endTime}
    };

    // Optionally override the company-id header
    if (companyId) {
      config.headers = {
        'x-loaded-company-id': companyId,
        'x-loaded-suppress-subscription-errors': '1'
      };
    }

    $http.get(settings.mercHost + '/cashup-sets/', config).then(function(result) {
      deferred.resolve(result.data);
    }, function(result) {
      deferred.reject(result);
    });

    return deferred.promise;
  }

  function getSummary(start, end, interval) {
    var deferred = $q.defer();
    $http.get(settings.mercHost + '/cashup-sets/summary', {
      params: {start: start, end: end, interval: interval}
    }).then(function(result) {
      deferred.resolve(result.data);
    }, function(result) {
      deferred.reject(result);
    });

    return deferred.promise;
  }

  /**
   * Get a specific CashupSet
   *
   * @memberof CashupSets
   * @param  {String} id Id of the CashupSet to get
   * @return {Object} promise
   */
  function getCashupSet(id) {
    return CashupSet.get({id: id}).$promise;
  }

  /**
   * Get all POS tills
   *
   * @memberof CashupSets
   * @return {Object} promise
   */
  function getTills() {
    return Tills.query().$promise;
  }

  /**
   * Create a new CashupSet at the current time
   *
   * @memberof CashupSets
   * @return {Object} promise
   */
  function add() {
    return $http.post(settings.mercHost + '/cashup-sets');
  }

  /**
   * Update the enddate of a given CashupSet
   *
   * @memberof CashupSets
   * @param  {String} id Id of the CashupSet to update
   * @param  {String} endDate New enddate for the CashupSet
   * @return {Object} promise
   */
  function changeDate(id, endDate) {
    return $http.put(settings.mercHost + '/cashup-sets/' + id + '/update-end-date', {
      end: endDate
    });
  }

  /**
   * Add a new Cashup to a given CashupSet
   *
   * @memberof CashupSets
   * @param {String} tillIdentifier Id of the Till to Cashup
   * @param {String} cashupSetId Id of the CashupSet to add the Cashup to.
   */
  function addCashup(tillIdentifier, cashupSetId) {
    return $http.post(settings.mercHost + '/cashup-sets/' + cashupSetId + '/cashups', {
      tillIdentifier: tillIdentifier
    });
  }

  return {
    get: get,
    getSummary: getSummary,
    getCashupSet: getCashupSet,
    getTills: getTills,
    add: add,
    changeDate: changeDate,
    addCashup: addCashup
  };
}]);
